module.exports = __webpack_public_path__ + "static/switching-logo-ccb909c2e5c3de55aeb36e5e69ca4d8b.svg";